//================================ Function global =================================
function promiseFile(s1) {
	return new Promise((res, rej) => {
		s1.onload = function () {
			res();
		};
		s1.onerror = function () {
			rej();
		};
	});
}
function addCSS(src) {
	const el = document.createElement('link');
	el.rel = 'stylesheet';
	el.href = src;
	document.head.appendChild(el);
	return promiseFile(el);
}
function addScript(src) {
	const el = document.createElement('script');
	el.async = true;
	el.src = src;
	document.head.appendChild(el);
	return promiseFile(el);
}
function currencyWithRate(value) {
	return Shopify.currency.rate * value;
}
function formatCC(value, digit = 2) {
	if (T4SThemeSP.Currency) {
		let format = T4Sconfigs.moneyFormat;
		return T4SThemeSP.Currency.formatMoney(value, digit ? format : format.replace(/\{\{.*?\}\}/, '{{amount_no_decimals}}'));
	} else {
		value = value / 100;
		value = value
			.toLocaleString(Shopify.locale + '-' + Shopify.country, {
				style: 'currency',
				currency: Shopify.currency.active,
				maximumFractionDigits: digit,
			})
			.replace(/[^\d.,-]/g, '');
		return T4Sconfigs.moneyFormat.replace(/\{\{.*?\}\}/, value);
	}
}
function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}
function setCookie(name, value, days) {
	let expires = '';
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function queryParam(param, value = false, state = false, url = '') {
	const obj = new URL(url ? url : window.location.href);
	if (value !== false) {
		if (value) {
			obj.searchParams.set(param, value);
		} else {
			obj.searchParams.delete(param);
		}
		if (state) {
			window.history.replaceState({}, '', obj);
		}
		return obj;
	} else {
		return obj.searchParams.get(param);
	}
}
async function geoLocation() {
	let geo = getCookie('geo');
	if (geo) {
		// console.log("Geo found in cookies:", JSON.parse(geo).country_code);
		try {
			return JSON.parse(geo);
		} catch {
			return {};
		}
	} else {
		try {
			const response = await fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json');
			const data = await response.json();
			data.country_code = data.detected_values.country.handle;
			Shopify.geo_location = data.country_code;
			setCookie('geo', JSON.stringify(data), 7);
			// console.log("Geo fetched from API:", data.country_code);
			return data;
		} catch (error) {
			const defaultData = { country_code: 'US' };
			Shopify.geo_location = defaultData.country_code;
			// console.log('Error fetching geo, using default:', defaultData.country_code);
			return defaultData;
		}
	}
}
async function sleep(s) {
	await new Promise((r) => setTimeout(r, s * 1000));
}
//================================ End Function global =================================
//================================ Start Custom Menu Header =========================
$(document).ready(function () {
	let nb_menu_link_touch = false;
	var header_inline = $('#shopify-section-header-inline');
	var menu_nav = $('#t4s-nav-ul');
	menu_nav.on('hover', '.has--children', function (e) {
		if (window.innerWidth >= 1025) {
			if (!$(this).hasClass('is-action__hover')) {
				menu_nav.find('.is-action__hover').removeClass('is-action__hover');
			}
		}
		// $(this).addClass("is-action__hover");
	});
	menu_nav.on('touchstart', '.has--children', function (e) {
		if (!$(this).hasClass('is-action__hover')) {
			menu_nav.find('.is-action__hover').removeClass('is-action__hover');
			$(this).addClass('is-action__hover');
		} else {
			$(this).removeClass('is-action__hover');
		}
	});
	if (typeof screen.orientation != 'undefined') {
		screen.orientation.addEventListener('change', (event) => {
			header_inline.removeClass('open-menu').removeClass('open-menu-child');
			menu_nav.find('.btn-close-menu-child').remove();
			menu_nav.find('.active-menu-child').removeClass('active-menu-child');
			menu_nav.find('.is-action__hover').removeClass('is-action__hover');
		});
	}
	menu_nav.on('click', '.has--children', function (e) {
		if (window.innerWidth >= 1025) {
			$(this).toggleClass('is-action__hover');
		}
	});
	$(document).on('click', function (e) {
		if (window.innerWidth >= 1025) {
			if (!$(e.target).hasClass('.has--children') && $(e.target).closest('.has--children').length == 0) {
				menu_nav.find('.is-action__hover').removeClass('is-action__hover');
			}
		}
	});
	header_inline.on('click', '.nb-btn-menu-mb', function (e) {
		// console.log(e);
		nb_menu_link_touch = false;
		header_inline.toggleClass('open-menu');
		if (!header_inline.hasClass('open-menu')) {
			header_inline.removeClass('open-menu-child');
			header_inline.find('li').removeClass('active-menu-child');
			if (window.innerWidth < 1025) {
				header_inline.find('li').removeClass('is-action__hover');
			}
		}
		$('body').toggleClass('t4s-lock-scroll-menu');
	});
	menu_nav.on('touchstart', '.has--children .nb-menu-item-link', function (e) {
		e.preventDefault();
		nb_menu_link_touch = true;
		toggleMenuMobile(this);
	});
	menu_nav.on('click', '.has--children .nb-menu-item-link', function (e) {
		e.preventDefault();
		if (!nb_menu_link_touch) {
			toggleMenuMobile(this);
		}
	});
	function toggleMenuMobile(that) {
		let mn = $(that).closest('.t4s-menu-item');
		if ($(that).hasClass('btn-close-menu-child')) {
			header_inline.removeClass('open-menu-child');
			setTimeout(() => {
				mn.removeClass('active-menu-child');
			}, 400);
		} else {
			header_inline.addClass('open-menu-child');
			if (mn.find('.btn-close-menu-child').length == 0 && window.innerWidth < 1025) {
				let link = $(that).closest('a').clone();
				link.removeAttr('href').addClass('btn-close-menu-child');
				mn.find('.nb-mega-menu').prepend(link);
			}
			mn.addClass('active-menu-child');
		}
		nb_menu_link_touch = false;
	}
});
//================================ End Custom Menu Header =============================

//================================ Custom Cart Drawer =================================
function paramATC(that) {
	let id = $(that).data('id');
	let property = $(that).data('property');
	let selling_plan = $(that).data('selling_plan');
	let ids = id.toString().split('|');
	let p = {};
	let properties = {};
	if (property) {
		properties = property;
	}
	if (ids.length > 1) {
		p = { items: [] };
		for (let i = 0; i < ids.length; i++) {
			p.items.push({ id: ids[i], properties, selling_plan });
		}
	} else {
		p = { id, properties, selling_plan };
	}
	return p;
}
$(document).on('click', '[data-add-to-cart]', function (event) {
	$(this).addClass('is--loading');
	$(this).find('.t4s-loading__spinner, .t4s-loading__spinner svg').removeAttr('hidden');
	NuBestCart.add(paramATC(this), {
		open: true,
		done: (cart) => {
			$(this).removeClass('is--loading');
			$(this).find('.t4s-loading__spinner, .t4s-loading__spinner svg').attr('hidden', true);
		},
	});
});
$(document).on('change', '.subscription-radio select', function (event) {
	// console.log("selling_plan_select change:", this.value);
	$(this).closest('form').find('input[name="selling_plan"]').val(this.value).trigger('change');
});
$(document).on('change', 'input.selling_plan_option', function (event) {
	// console.log("selling_plan_option change:", this.value);
	let form = $(this).closest('form');
	let nb_sp_radios = $(this).closest('.nb-sp-widget').find('.sp-radio');
	let sp_radio = $(this).closest('.sp-radio');
	if (this.value == 'subscription') {
		$(this).closest('[data-product-featured]').find('.sp-list-opt').trigger('change');
	} else {
		form.find('input[name="selling_plan"]').val('').trigger('change');
	}
});
$(document).on('change', 'input.sp-radio__input', function (event) {
	$(this).closest('.nb-sp-widget').find('.sp-radio').removeClass('sp-radio--active');
	$(this).closest('.sp-radio').addClass('sp-radio--active');
});
$('input.sp-radio__input:checked').trigger('change');
//================================ End Custom Cart Drawer =================================
//================================ Marketing event cookie =================================
function tamix_checkCookieQuery(query) {
	let cookieValue = decodeURIComponent(getCookie('_shopify_sa_p'));
	if (!cookieValue) {
		return false;
	}
	const queries = query.split('&');
	for (let i = 0; i < queries.length; i++) {
		let [key, value] = queries[i].split('=');
		if (value) {
			if (value.endsWith('*')) {
				value = value.slice(0, -1);
				const regex = new RegExp(`${key}=${value}[a-zA-Z0-9_]*`);
				if (!regex.test(cookieValue)) {
					return false;
				}
			} else {
				const regex = new RegExp(`${key}=${value}(?![a-zA-Z0-9_])`);
				if (!regex.test(cookieValue)) {
					return false;
				}
			}
		} else {
			return false;
		}
	}
	return true;
}
function tamix_extractLinks() {
	let links = document.querySelectorAll('a.tamix-ecommerce-button');
	links.forEach(function (link) {
		let dataLink = link.getAttribute('data-link');
		if (dataLink) {
			let segments = dataLink.split(';tamix;');
			segments.forEach(function (segment) {
				let index = segment.indexOf('|');
				if (index !== -1) {
					let name = segment.substring(0, index);
					let url = segment.substring(index + 1);
					if (tamix_checkCookieQuery(name)) {
						link.href = url;
						// console.log(`Updated href to ${url} for link with id ${link.id}`);
					}
				}
			});
		}
	});
	document.querySelectorAll('.tamix-ecommerce-buttons-item').forEach(function (item) {
		const link = item.querySelector('a.tamix-ecommerce-button');
		if (link) {
			const href = link.getAttribute('href');
			if (href === '' || href === null || !href.trim()) {
				item.remove();
			}
		}
	});
}
tamix_extractLinks();
//================================ End Marketing event cookie =================================
//================================ Effect new-block-04 =================================
var tamix_linkbarMid = 0;
var tamix_heighttop = 0;
var tamix_firstTop = 0;
var tamix_lastTop = 0;
const tamix_progressionElements = Array.from(document.querySelectorAll('.item-progression'));
const tamix_linkbarElement = document.querySelector('.block-progression .link-bar');
if (tamix_progressionElements.length && tamix_linkbarElement) {
	let tamixProgressionTicking = false;
	const updateTamixProgression = () => {
		tamixProgressionTicking = false;
		const windowHeight = window.innerHeight;
		const measurements = tamix_progressionElements
			.map((element) => {
				const dotElement = element.querySelector('.tamix-grid .img .dot');
				if (!dotElement) return null;
				return {
					element,
					elementPosition: element.getBoundingClientRect(),
					dotPosition: dotElement.getBoundingClientRect(),
				};
			})
			.filter(Boolean);
		let linkbarTop = null;
		let linkbarBottom = null;
		measurements.forEach(({ element, elementPosition, dotPosition }) => {
			const dotTop = dotPosition.top;
			element.classList.toggle('display', dotTop < windowHeight / 2);
			if (element.classList.contains('first')) {
				tamix_firstTop = dotTop;
				linkbarTop = dotTop - elementPosition.top + 15;
			}
			if (element.classList.contains('last')) {
				tamix_lastTop = dotTop;
				const heightbot = elementPosition.bottom - dotPosition.bottom + 15;
				const adjustedBottom = elementPosition.top - windowHeight / 2 + heightbot + tamix_heighttop;
				if (tamix_lastTop - 45 > windowHeight / 2) {
					tamix_linkbarMid = windowHeight / 2 - tamix_lastTop;
					linkbarBottom = adjustedBottom;
				} else {
					linkbarBottom = heightbot;
				}
			}
		});
		if (linkbarTop !== null) tamix_linkbarElement.style.top = `${linkbarTop}px`;
		if (linkbarBottom !== null) tamix_linkbarElement.style.bottom = `${linkbarBottom}px`;
	};
	const requestTamixProgressionUpdate = () => {
		if (tamixProgressionTicking) return;
		tamixProgressionTicking = true;
		requestAnimationFrame(updateTamixProgression);
	};
	window.addEventListener('scroll', requestTamixProgressionUpdate, { passive: true });
	window.addEventListener('resize', requestTamixProgressionUpdate, { passive: true });
	requestTamixProgressionUpdate();
}
//================================ End Effect new-block-04 =================================
//================================ Open cross domain to blank =================================
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
	if (links[i].hostname !== window.location.hostname) {
		links[i].target = '_blank';
		let rel = links[i].rel;
		let rels = ['noopener', 'noreferrer'];
		for (let index = 0; index < rels.length; index++) {
			if (rel.indexOf(rels[index]) === -1) {
				rel += ' ' + rels[index];
			}
		}
		links[i].rel = rel;
	}
}
//================================ End Open cross domain to blank =================================
//================================ tamix-ecommerce-buttons-block =================================
function display_ecommerce_botton(elem4 = '') {
	(async () => {
		const data = await geoLocation();
		// console.log("Final geo data:", data.country_code);
		// const country = data.country_name;
		let buttons = [];
		if (elem4 != '') {
			buttons = elem4.querySelectorAll('.tamix-ecommerce-buttons-item');
		} else {
			buttons = document.querySelectorAll('.tamix-ecommerce-buttons-item');
		}
		let buttonAvaiable = 0;
		buttons.forEach(function (button) {
			let dataNation = button.getAttribute('data-nation');
			if (!dataNation || dataNation.includes(data.country_code)) {
				button.remove();
			} else {
				buttonAvaiable = buttonAvaiable + 1;
			}
		});
		if (buttonAvaiable > 0) {
			let addClass = 'flex-onlyone';
			if (buttonAvaiable >= 2 && buttonAvaiable % 2 == 1) {
				addClass = 'flex-odd';
			} else if (buttonAvaiable >= 2 && buttonAvaiable % 2 == 0) {
				addClass = 'flex-even';
			}
			if (elem4 != '') {
				buttons = elem4.querySelectorAll('.tamix-ecommerce-buttons-item');
			} else {
				buttons = document.querySelectorAll('.tamix-ecommerce-buttons-item');
			}
			buttons.forEach(function (button) {
				button.classList.add(addClass);
				button.classList.add('display_on');
				let dataReplace = button.getAttribute('data-replace_addtocart_button_block');
				//console.log("dataReplace");
				//console.log(dataReplace);
				// console.log(button);
				if (dataReplace == 'true') {
					document.querySelectorAll('.replace_addtocart_button_block').forEach((element) => {
						if (!element.classList.contains('display_off')) {
							element.classList.add('display_off');
						}
					});
					if (elem4 == '') {
						var style = document.createElement('style');
						style.innerHTML = `.t4s-sticky-atc .t4s-sticky-atc__btns .t4s-sticky-atc__atc{display:none !important}.t4s-sticky-atc .t4s-sticky-atc__btns .tamix-ecommerce-buttons-block{display:block !important;width:100%}.t4s-sticky-atc .t4s-sticky-atc__btns .tamix-ecommerce-buttons-block .tamix-ecommerce-buttons{margin-bottom:15px}`;
						document.head.appendChild(style);
					}
				}
			});
			// console.log('buttonAvaiable');
			// console.log(buttonAvaiable);
			if (buttonAvaiable > 1) {
				let el;
				if (elem4 != '') {
					el = elem4.querySelector('.tamix-ecommerce-buttons-title');
				} else {
					el = document.querySelector('.tamix-ecommerce-buttons-title');
				}
				if (el) {
					el.classList.add('display_on');
				}
			} else {
				if (elem4 != '') {
					elem4.querySelector('.tamix-ecommerce-button .buyon').classList.add('display_on');
				} else {
					document.querySelector('.tamix-ecommerce-button .buyon').classList.add('display_on');
				}
			}
		}
	})();
}
if (document.querySelector('.tamix-ecommerce-buttons-item')) {
	// console.log("call first");
	display_ecommerce_botton();
} else {
	geoLocation();
}
//================================ End tamix-ecommerce-buttons-block =================================
async function copyTextToClipboard(text, success = null, error = null) {
	try {
		await navigator.clipboard.writeText(text);
		if (success) success();
	} catch (err) {
		console.error('Copy failed:', err);
		if (error) error();
	}
}
function addNotifeedItems(node, items = []) {
	if (!node || !node.hasAttribute('data-atomato-notifeeds-host')) return;
	if (!items.length || !node.shadowRoot) return;
	const countEl = document.querySelector('[data-notifeed-bell-count]');
	const powered = node.shadowRoot.querySelector('div#atomato-app a[data-notifeed-powered]');
	if (powered) powered.remove();
	const inner = node.shadowRoot.querySelector('div#atomato-app div[data-notifeed-list-inner]');

	if (!countEl || !inner) return;
	const list = inner.querySelector('ul[data-notifeed-list]');
	if (!list) return;
	const copyText = (el) => {
		const content = el.closest('[data-notifeed-content]');
		const title = content && content.querySelector('[data-notifeed-title]');
		if (!title) return;
		copyTextToClipboard(title.textContent, () => {
			el.textContent = 'Copied';
			setTimeout(() => (el.textContent = 'Copy'), 1500);
		});
	};
	list.querySelectorAll('[data-notifeed-button][aria-label="Copy"]').forEach((btn) => {
		if (btn.dataset.copyBound === 'true') return;
		btn.dataset.copyBound = 'true';
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			copyText(btn);
		});
	});
	const template = list.querySelector('li');
	if (!template) return;
	const existingTitles = new Set([...list.querySelectorAll('[data-notifeed-title]')].map((el) => el.textContent.trim()));
	const uniqueItems = items.filter((item) => {
		const code = item.code;
		if (!code || existingTitles.has(code)) return false;
		existingTitles.add(code);
		return true;
	});
	if (!uniqueItems.length) return;
	countEl.textContent = (parseInt(countEl.textContent, 10) || 0) + uniqueItems.length;
	const fragment = document.createDocumentFragment();
	const itemHeight = template.offsetHeight || 0;
	uniqueItems.forEach((item) => {
		const clone = template.cloneNode(true);
		const btn = clone.querySelector('[data-notifeed-button]');
		const media = clone.querySelector('[data-notifeed-media]');
		const title = clone.querySelector('[data-notifeed-title]');
		const desc = clone.querySelector('[data-notifeed-description]');
		if (!btn || !title || !desc) return;
		clone.setAttribute('is-new', '');
		title.textContent = item.title || item.code;
		desc.textContent = item.description || 'Use your discount code at checkout.';
		btn.textContent = item.code ? 'Copy' : 'View';
		btn.setAttribute('aria-label', item.code ? 'Copy discount code' : 'View');
		if (item.code) {
			btn.removeAttribute('href');
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				copyText(btn);
			});
		} else if (item.url) {
			btn.setAttribute('href', item.url);
		}
		if (media) {
			media.innerHTML = `<img src="${item.src || '//cdn.shopify.com/s/files/1/0799/8432/8989/files/discount-code.png?v=1780626609&width=240&height=240&crop=center'}" width="80" height="80" draggable="false">`;
		}
		fragment.appendChild(clone);
	});
	list.insertBefore(fragment, template);
	const currentHeight = parseInt(getComputedStyle(inner).getPropertyValue('--noti-height'), 10) || 0;
	inner.style.setProperty('--noti-height', `${currentHeight + itemHeight * uniqueItems.length}px`);
}
//================================ MutationObserver =================================
const tamixBody = document.getElementById('tamix-body');
if (tamixBody) {
	const observerQueue = new Set();
	let observerFrame = 0;
	const processObserverQueue = () => {
		observerFrame = 0;
		const nodes = Array.from(observerQueue);
		observerQueue.clear();
		const discountCode = getCookie('discount_code');
		nodes.forEach((node) => {
			const ecommerceBlocks = node.matches('.tamix-ecommerce-buttons-block') ? [node] : node.querySelectorAll('.tamix-ecommerce-buttons-block');
			ecommerceBlocks.forEach((element) => display_ecommerce_botton(element));
			addNotifeedItems(node, [{ code: discountCode ? discountCode.toUpperCase() : null }]);
		});
	};
	const observer2 = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node instanceof HTMLElement) observerQueue.add(node);
			});
		});
		if (observerQueue.size && !observerFrame) observerFrame = requestAnimationFrame(processObserverQueue);
	});
	observer2.observe(tamixBody, {
		childList: true,
		subtree: true,
	});
}
//================================ End MutationObserver =================================
//================================ Slider =================================
if (typeof Swiper == 'function') {
	let swiper = new Swiper('.swiper-container.two', {
		effect: 'coverflow',
		loop: true,
		centeredSlides: true,
		slidesPerView: 2,
		slideToClickedSlide: true,
		observer: true,
		observeParents: true,
		parallax: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		coverflow: {
			rotate: 0,
			stretch: -300,
			depth: 250,
			modifier: 1.5,
			slideShadows: false,
		},
	});
}
$(document).ready(function () {
	$('.PDP-newOddit-Block05-Carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		let num = nextSlide + 1;
		$('.PDPnewOdditBlock05-nav-item').removeClass('active');
		$('.PDPnewOdditBlock05-nav-item-' + num).addClass('active');
		var scrollableElement = document.getElementById('block-nav');
		// console.log((num - 1) * 135);
		scrollableElement.scrollBy((nextSlide - 1) * 135, 0);
	});
	$('.PDP-newOddit-Block05-Carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
				},
			},
		],
	});
	$('.HGS-Facts-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
	});
	var HGSmaxHeight = 0;
	$('.HGS-Facts-slider .column-grid-item').each(function () {
		var HGSthisHeight = $(this).outerHeight();
		if (HGSthisHeight > HGSmaxHeight) {
			HGSmaxHeight = HGSthisHeight;
		}
	});
	$('.HGS-Facts-slider .column-grid-item').css('height', HGSmaxHeight + 'px');
	$('a[href="#disable"]').on('touchstart click', function (event) {
		event.preventDefault();
	});
	$('.slider-blog').slick({
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					dots: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
				},
			},
		],
	});
	$('.slider-inside').slick({
		autoplay: true,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 2,
					slidesToScroll: 1,
					autoplay: true,
				},
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
				},
			},
		],
	});
});
//================================ End Slider =================================
//================================ Snippet tamix-video =================================
function playVideo(id_video) {
	let tamix_video_button = event.target;
	let tamix_video_videoContainer = tamix_video_button.closest('.video-container');
	let tamix_video_imgContainer = tamix_video_videoContainer.querySelector('.img');
	let tamix_video_iframeContainer = tamix_video_videoContainer.querySelector('.ifm');
	let tamix_video_blockIframeContainer = tamix_video_videoContainer.querySelector('.t4s-section-inner');
	let tamix_video_iframe = document.createElement('iframe');
	tamix_video_iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id_video + '?controls=1&autoplay=1&showinfo=0&rel=0&modestbranding=1');
	tamix_video_iframe.setAttribute('class', 'frm');
	tamix_video_iframeContainer.appendChild(tamix_video_iframe);
	tamix_video_imgContainer.style.display = 'none';
	tamix_video_button.style.display = 'none';
	tamix_video_blockIframeContainer.style.display = 'block';
}
//================================ End Snippet tamix-video =================================
//================================ Snippet product-form =================================
function variant_more_options() {
	let tamix_target = event.target;
	let tamix_container = tamix_target.closest('.t4s-swatch__list');
	let tamix_block_button = tamix_container.querySelector('.block-btn');
	let tamixGridElements = tamix_container.querySelectorAll('.t4s-swatch__item');
	tamixGridElements.forEach((tamixGridElement) => {
		tamixGridElement.classList.remove('is__hidden');
	});
	tamix_block_button.style.display = 'none';
}
//================================ End Snippet product-form =================================
//================================ Snippet tamix-faqs =================================
function showcontent() {
	let tamix_faqs_target = event.target.closest('.question');
	if (!tamix_faqs_target) return;
	let tamix_faqs_container = tamix_faqs_target.closest('.item');
	let tamix_faqs_group = tamix_faqs_container.closest('.group_onlyone_faqs');
	let tamix_faqs_answer = tamix_faqs_container.querySelector('.answer');
	let tamix_faqs_icon = tamix_faqs_container.querySelector('.fas');
	if (!tamix_faqs_answer) return;
	let isActive = tamix_faqs_target.classList.contains('active');
	if (tamix_faqs_group) {
		tamix_faqs_group.querySelectorAll('.item').forEach((item) => {
			if (item !== tamix_faqs_container) {
				item.querySelector('.question').classList.remove('active');
				item.querySelector('.answer').classList.remove('show');
				let icon = item.querySelector('.fas');
				if (icon) {
					icon.classList.add('fa-plus');
					icon.classList.remove('fa-minus');
				}
			}
		});
	}
	const tamix_faqs_wrapper = tamix_faqs_target.closest('.newOddit-faqs-show-only-one');
	if (tamix_faqs_wrapper) {
		tamix_faqs_wrapper.querySelectorAll('.question.active').forEach((el) => {
			if (el !== tamix_faqs_target) {
				el.classList.remove('active');
			}
		});
		tamix_faqs_wrapper.querySelectorAll('.answer.show').forEach((el) => {
			if (el !== tamix_faqs_answer) {
				el.classList.remove('show');
			}
		});
		tamix_faqs_wrapper.querySelectorAll('.fa-minus').forEach((icon) => {
			// bỏ qua icon nằm trong question đang được click
			if (!tamix_faqs_target.contains(icon)) {
				icon.classList.remove('fa-minus');
				icon.classList.add('fa-plus');
			}
		});
	}
	tamix_faqs_target.classList.toggle('active');
	tamix_faqs_answer.classList.toggle('show');
	if (tamix_faqs_icon) {
		tamix_faqs_icon.classList.toggle('fa-minus');
		tamix_faqs_icon.classList.toggle('fa-plus');
	}
	setTimeout(() => {
		let rect = tamix_faqs_target.getBoundingClientRect();
		let viewportHeight = window.innerHeight;
		if (rect.top < 0 || rect.bottom > viewportHeight) {
			let scrollOffset = window.scrollY + rect.top - 200;
			window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
		}
	}, 300);
}
function tamix_showmore() {
	let tamix_faqs_target = event.target.closest('.tamix_showmore');
	if (!tamix_faqs_target) return;
	tamix_faqs_target.classList.toggle('show');
}
function loadmoreFAQS(cls = 'BaseFAQs', length, limit = 6) {
	let tamix_faqs_target = event.target;
	let tamix_faqs_container = tamix_faqs_target.closest('.' + cls);
	let hiddenElements = tamix_faqs_container.querySelectorAll('.tamix-hidden');
	for (var i = 0; i < limit && i < hiddenElements.length; i++) {
		hiddenElements[i].classList.remove('tamix-hidden');
	}
	let hiddenElements2 = tamix_faqs_container.querySelectorAll('.tamix-hidden');
	if (hiddenElements2.length == 0) {
		tamix_faqs_target.classList.add('tamix-hidden');
	}
}
//================================ End Snippet tamix-faqs =================================
//================================ Loadmore Ingredients =================================
function loadmoreIngredient() {
	let tamix_target = event.target;
	let tamix_block_07 = tamix_target.closest('.Product-Detail-New-Block-07-Howitsmade');
	let tamix_block_button = tamix_block_07.querySelector('.block-btn');
	let tamixGridElements = tamix_block_07.querySelectorAll('.tamix-grid');
	tamixGridElements.forEach((tamixGridElement) => {
		tamixGridElement.classList.remove('hidden');
	});
	tamix_block_button.style.display = 'none';
}
//================================ End Loadmore Ingredients =================================
// Pages Refer A Friend - FAQs =========================================================
document.addEventListener('DOMContentLoaded', (event) => {
	var linkElement = document.querySelector('.here-yotpo-input');
	if (linkElement) {
		linkElement.addEventListener('click', function (event) {
			event.preventDefault();
			var inputElement = document.querySelector('.yotpo-input');
			if (inputElement) {
				inputElement.focus();
			} else {
				console.error('Input element not found.');
			}
		});
	}
});
//================================ End Pages Refer A Friend - FAQs =================================
//================================ ScrollTo target =================================
// Smooth scroll to an in-page anchor, stopping below the sticky header (dev, Oct 2026).
// Fixed 27 Oct 2026: no error on href="#" or odd hashes, works when the v2.1 header is off, and leaves alone
// links that already have their own handler (policy TOC, Shop by age, Kalles drawers/tabs/popups).
document.addEventListener('DOMContentLoaded', function () {
	var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
	function stickyHeaderHeight() {
		var h = document.getElementById('nbh-header') || document.querySelector('.t4s-section-header, #shopify-section-header-inline');
		if (!h) return 0;
		var r = h.getBoundingClientRect();
		return r.bottom > 0 ? Math.round(r.height) : 0;
	}
	$(document).on('click', 'a[href^="#"]', function (event) {
		if (event.isDefaultPrevented()) return; // another script already handles this link
		var a = this;
		var hash = a.getAttribute('href') || '';
		if (hash.length < 2 || hash === '#!' || hash === '#0') return; // placeholder links: nothing to scroll to
		if (a.hasAttribute('role') || a.hasAttribute('aria-controls') || a.hasAttribute('data-toggle') ||
			a.matches('[data-drawer-options],[data-drawer-delay],[data-t4s-tab],[data-tab],[data-open-popup],[data-action-popup]') ||
			a.closest('.t4s-drawer,.t4s-tabs-ul,[role="tablist"],.nb-toc-container')) return; // UI controls, not page anchors
		var id;
		try { id = decodeURIComponent(hash.slice(1)); } catch (e) { return; }
		var el = document.getElementById(id);
		if (!el && window.CSS && CSS.escape) el = document.querySelector('a[name="' + CSS.escape(id) + '"]');
		if (!el || el.closest('.t4s-drawer,[aria-hidden="true"],dialog:not([open])')) return;
		if (el.getClientRects().length === 0) return; // hidden target: let the browser decide
		event.preventDefault();
		var pdTop = parseFloat(getComputedStyle(el).paddingTop) || 0;
		var top = el.getBoundingClientRect().top + window.pageYOffset + pdTop - stickyHeaderHeight() - 15;
		var done = function () {
			if (!el.matches('a[href],button,input,select,textarea,[tabindex]')) el.setAttribute('tabindex', '-1');
			try { el.focus({ preventScroll: true }); } catch (e) {}
			if (history.replaceState) history.replaceState(null, '', '#' + id);
		};
		$('html, body').stop(true).animate({ scrollTop: Math.max(0, top) }, reduce.matches ? 0 : 750).promise().done(done);
	});
});
//================================ End ScrollTo target =================================
//================================ TOC article =================================
document.addEventListener('DOMContentLoaded', function () {
	let $toc_contain = document.querySelector('.nb-toc-container');
	if ($toc_contain) {
		const content = document.querySelector('.t4s-main-article-page .t4s-article-content');
		$(document).on('click', 'a[href^="#"].nb-toc-item-link', function (event) {
			event.preventDefault();
			let $toc = $('#nb-toc-article');
			if (window.innerWidth < 1024) {
				$toc.removeClass('active');
			}
			let viewportTop = $(window).scrollTop();
			let viewportBottom = viewportTop + $(window).height();
			let el = $($(this).attr('href'));
			let rect = el.offset();
			let top = rect.top;
			let bottom = top + el.outerHeight();
			if (bottom < viewportTop) {
				top -= ($('#shopify-section-header-inline, #shopify-section-nb-header').first().outerHeight() || 0);
				// top -= $toc.outerHeight();
			}
			$('html, body').animate({ scrollTop: top - 15 }, 1000);
		});
		$(document).on('click', '.nb-toc-title', function (event) {
			let a = $(this).closest('#nb-toc-article');
			a.toggleClass('active');
		});
		const toc = document.getElementById('nb-toc-article');
		let tocTicking = false;
		let tocFixed = null;
		const updateTocPosition = () => {
			tocTicking = false;
			const top = toc.parentElement.getBoundingClientRect().top;
			const limit = content.getBoundingClientRect().bottom;
			const shouldFix = top <= 0 && limit >= 0;
			if (shouldFix === tocFixed) return;
			tocFixed = shouldFix;
			toc.classList.toggle('fixed', shouldFix);
			toc.classList.toggle('no-fixed', !shouldFix);
		};
		const requestTocUpdate = () => {
			if (tocTicking) return;
			tocTicking = true;
			requestAnimationFrame(updateTocPosition);
		};
		window.addEventListener('scroll', requestTocUpdate, { passive: true });
		window.addEventListener('resize', requestTocUpdate, { passive: true });
		requestTocUpdate();
		const headings = content.querySelectorAll('h2, h3, h4, h5, h6');
		if (headings.length) {
			function getTOCItem(id, el) {
				id = 'toc-' + id;
				el.setAttribute('id', id);
				let $li = document.createElement('li');
				let $a = document.createElement('a');
				$a.className = 'nb-toc-item-link';
				$a.href = '#' + id;
				$a.title = el.textContent.trim().replace(/^[1-9]\./, '');
				$a.textContent = $a.title;
				$li.appendChild($a);
				return $li;
			}
			function buildTOC(items, currentLevel = 2) {
				let $ol = document.createElement('ol');
				$ol.className = 'nb-toc-list';
				let time = new Date().getTime();
				while (items.length) {
					const currentItem = items[0];
					const currentLevelNumber = parseInt(currentItem.tagName[1]);
					if (currentLevelNumber === currentLevel) {
						let $li = getTOCItem(time + items.length, currentItem);
						items.shift();
						const subItems = buildTOC(items, currentLevel + 1);
						if (subItems.childNodes.length) {
							$li.appendChild(subItems);
						}
						$ol.appendChild($li);
					} else if (currentLevelNumber > currentLevel) {
						break;
					} else {
						return $ol;
					}
				}
				return $ol;
			}
			let $toc = document.getElementById('nb-toc-article');
			let $toc_ol = buildTOC(Array.from(headings));
			$toc.appendChild($toc_ol);
		}
	}
});
//================================ End TOC article =================================
//================================ Loadmore Author =================================
$('.t4s-loadmore-btn-author').on('click', function () {
	let limit = $(this).data('limit');
	let $wrap = $(this).closest('[data-ntajax-options]');
	let allItems = $wrap.find('article.t4s-post-item');
	// console.log(allItems.length);
	let hiddenItems = $wrap.find('article.t4s-post-item.t4s-d-none');
	// console.log(hiddenItems.length);
	for (let i = 0; i < limit && i < hiddenItems.length; i++) {
		hiddenItems[i].classList.remove('t4s-d-none');
	}
	hiddenItems = $wrap.find('article.t4s-post-item.t4s-d-none');
	let displayedItems = allItems.length - hiddenItems.length;
	let percentageDisplayed = (displayedItems / allItems.length) * 100;
	$wrap.find('[data-current-bar]').text(displayedItems);
	$wrap.find('.t4s-lm-bar--current').css('width', percentageDisplayed + '%');
	if (hiddenItems.length === 0) {
		$(this).hide();
	}
});
//================================ End Loadmore Author =================================
//================================ Variant switcher =====================================
function checkShowVariantPopup(data) {
	for (let j = 0; j < Shopify.cart.items.length; j++) {
		let item = Shopify.cart.items[j];
		if (!data.quantity || data.quantity > 1 || item.id != data.id || getCookie('popupswitchvariant.' + data.id)) {
			continue;
		}
		let url = data.url.split('?')[0];
		NuBestCart.section('popupswitchvariant', {
			done: (sections) => {
				let $popup = $(sections);
				$popup.find(`.popup-variant-item:not([data-variant-id="${data.id}"])`).remove();
				if ($popup.find(`.popup-variant-item`).length) {
					let popupVariant = $('body').find(`.popup-variant-item[data-variant-id="${data.id}"]`);
					if (popupVariant.length == 0) {
						$('body').append($popup[0]);
					} else {
						popupVariant.addClass('active');
					}
				}
			},
		});
	}
}
$(document).ready(function () {
	$(document).on('click', '.popup-variant-close', function (e) {
		$(this).closest('.popup-variant-switch').remove();
	});
	$(document).on('click', '[data-switch-variant]', function (e) {
		let $this = $(this);
		let key = $this.data('key');
		let id = $this.data('switch');
		$this.addClass('is--loading');
		$this.find('.t4s-loading__spinner').removeAttr('hidden');
		$this.find('.t4s-loading__spinner svg').removeAttr('hidden');
		$this.closest('[data-cart-item]').addClass('is--update');
		let properties = {};
		if ($this.data('property')) {
			properties[$this.data('property')] = 'true';
		}
		NuBestCart.swap(
			key,
			{ id: id, selling_plan: $this.data('selling-plan'), properties: properties },
			{
				open: true,
				done: (cart) => {
					if ($this.closest('[data-variant-id]').length) {
						setCookie('popupswitchvariant.' + $this.closest('[data-variant-id]').data('variant-id'), true, 7);
					}
					if ($('.popup-variant-close').length) {
						$('.popup-variant-close').trigger('click');
					}
					$this.removeClass('is--loading');
					$this.find('.t4s-loading__spinner').attr('hidden', true);
					$this.find('.t4s-loading__spinner svg').attr('hidden', true);
				},
			},
		);
	});
});
//================================ End Variant switcher =====================================
// ================================ Fancybox ===============================================
$(document).ready(function () {
	if ($('[data-fancybox]').length) {
		addCSS('/cdn/shop/t/83/assets/fancybox.css');
		addScript('/cdn/shop/t/83/assets/fancybox.umd.js').then(() => {
			Fancybox.bind('[data-fancybox]', {});
		});
	}
});
// ================================ End Fancybox ===============================================
//================================ Frequently Bought Together =====================================
$(document).ready(function () {
	let $fbt = $('.PDP-newOddit-Block-FBT');
	$(document).on('change', '.FBT-product-checkbox', function (e) {
		$fbt.find(`.FBT-product-item[data-vid="${this.value}"]`).toggle(this.checked);
		let products = $fbt.find('.FBT-product-checkbox:checked');
		let price = 0;
		let ids = [];
		for (let i = 0; i < products.length; i++) {
			let product = products[i];
			price += $(product).data('price');
			ids.push(product.value);
			if (i + 1 == products.length) {
				$fbt.find(`.FBT-product-item`).removeClass('last-item');
				$fbt.find(`.FBT-product-item[data-vid="${product.value}"]`).addClass('last-item');
			}
		}
		$fbt.find('.FBT-total-price').html(formatCC(price));
		let btnATC = $fbt.find('[data-add-to-cart]');
		btnATC.attr('data-id', ids.join('|'));
		btnATC.data('id', ids.join('|'));
		btnATC.prop('disabled', products.length == 0);
	});
});
//================================ End Frequently Bought Together =====================================
//================================ tamix tooltips =================================
function getTamixTooltipPosition(iconRect) {
	const viewportWidth = window.innerWidth;
	const viewportHeight = window.innerHeight;
	const margin = 16;
	const tooltipWidth = Math.min(360, 0.7 * viewportWidth);
	const tooltipHeight = 200;
	let left = 0;
	left += 'px';
	let right = tooltipWidth;
	let transY = 0;
	if (viewportWidth - iconRect.right < margin + tooltipWidth) {
		left = 'auto';
		right = viewportWidth - iconRect.right - margin;
	}
	let arr_left = 4;
	if (tooltipWidth - right > 8) {
		arr_left = tooltipWidth - right - 12;
	}
	arr_left += 'px';
	let arr_top = 'auto';
	let arr_bottom = '-4px';
	let arr_tranZ = ' 0';
	if (iconRect.top < tooltipHeight) {
		transY = ' calc( 100% + 32px )';
		arr_tranZ = ' 180deg';
		arr_top = '-4px';
		arr_bottom = 'auto';
	}
	return {
		transY,
		left,
		right,
		arr_left,
		arr_top,
		arr_bottom,
		arr_tranZ,
	};
}
function setupTamixTooltipPosition(tooltip) {
	const icon = tooltip.querySelector('.tooltips-icon');
	const content = tooltip.querySelector('.tooltips-content');
	if (!icon || !content) return;
	if (tooltip.dataset.tamixTooltipInit === 'true') return;
	tooltip.dataset.tamixTooltipInit = 'true';
	icon.addEventListener('mouseenter', () => {
		const iconRect = icon.getBoundingClientRect();
		const pos = getTamixTooltipPosition(iconRect);
		// console.log(pos);
		content.style.position = 'absolute';
		content.style.left = `${pos.left}`;
		content.style.right = `-${pos.right}px`;
		content.style.transform = `translate(0, ${pos.transY})`;
		content.style.setProperty('--tamix-tooltip-arrow-left', `${pos.arr_left}`);
		content.style.setProperty('--tamix-tooltip-arrow-top', `${pos.arr_top}`);
		content.style.setProperty('--tamix-tooltip-arrow-bottom', `${pos.arr_bottom}`);
		content.style.setProperty('--tamix-tooltip-arrow-tranz', `${pos.arr_tranZ}`);
	});
}
function initTamixTooltipsWithObserver() {
	document.querySelectorAll('.tamix-tooltips').forEach(setupTamixTooltipPosition);
	const tooltipQueue = new Set();
	let tooltipFrame = 0;
	const processTooltipQueue = () => {
		tooltipFrame = 0;
		tooltipQueue.forEach((node) => {
			if (node.matches('.tamix-tooltips')) setupTamixTooltipPosition(node);
			node.querySelectorAll('.tamix-tooltips').forEach(setupTamixTooltipPosition);
		});
		tooltipQueue.clear();
	};
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof Element)) return;
				tooltipQueue.add(node);
			});
		});
		if (tooltipQueue.size && !tooltipFrame) tooltipFrame = requestAnimationFrame(processTooltipQueue);
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
}
document.addEventListener('DOMContentLoaded', initTamixTooltipsWithObserver);
//================================ tamix tooltips =================================
//================================ Popup Ingredient =====================================
$(document).ready(function () {
	$(document).on('click', '.tamix-popup-ingredient', function (e) {
		let $popup = $($(this).data('target'));
		$popup.find(`[data-ingredient-title]`).html($(this).data('title'));
		let $content = $popup.find(`[data-ingredient-content]`);
		let $wrap = $popup.find('.t4s-drawer__wrap');
		// $content.closest('.t4s-drawer__wrap').addClass('is--loading');
		$content.html('');
		T4SThemeSP.Drawer.opend($popup);
		addCSS('/cdn/shop/t/170/assets/supplement-facts.css?v=133289130345025828681785483079');
		NuBestCart.section('product-ingredient', {
			done: (sections) => {
				$content.html($(sections).find(`[data-ingredient-html]`).html());
			},
		});
	});
});
//================================ End Popup Ingredient =====================================
//================================ NuBest Gifts =====================================
async function checkNBGift(action = null) {
	let widget = '#nb-gift-widget';
	// if (typeof klaviyo != 'undefined') {
	// 	const identify = await klaviyo.isIdentified();
	// 	// console.log('checkNBGift identify', identify);
	// 	if (identify) {
	// 		const _kx = JSON.parse(atob(getCookie('__kla_id'))).$exchange_id;
	// 		if (!_kx) return;
	// 		const segment_id = 'XgTJyu';
	// 		const _key = `__kla_${segment_id}_${_kx}`;
	// 		// console.log('checkNBGift action', action);
	// 		if (action == 'submit_form') setCookie(_key, '', 3);
	// 		let _seg = getCookie(_key);
	// 		// console.log('checkNBGift _seg', _seg);
	// 		if (!_seg) {
	// 			const segment = await fetch('/tools/crm/klaviyo/segments', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ _kx, segment_id }) }).then((r) => r.json());
	// 			// console.log('checkNBGift segment', segment);
	// 			_seg = Object.keys(segment).length > 0 ? 'true' : 'false';
	// 			setCookie(_key, _seg, 3);
	// 		}
	// 		if (_seg == 'false') {
	// 			$(widget).removeClass('show');
	// 			return;
	// 		}
	// 	}
	// }
	let $g = $('#nb-gifts');
	if (!$g.length) return;
	let data;
	await NuBestCart.section('nb_gifts', {
		done: (sections) => {
			data = sections;
		},
	});
	if (!data) return;
	let $d = $(data);
	let iframe = '#nb-gift-iframe';
	let popup = '#nb-gift-popup';
	$g.find(iframe).replaceWith($d.find(iframe).toggleClass('show', $g.find(iframe).hasClass('show')));
			$(widget).addClass('show');
	// $g.find(popup)
	// 	.html($d.find(popup).html())
	// 	.promise()
	// 	.done(function () {
	// 		let pre = queryParam('nb_rewards') || getCookie('nb_rewards');
	// 		if (pre) {
	// 			const from = $g.data('from');
	// 			let dayLeft = 7;
	// 			if (from) {
	// 				dayLeft = Math.ceil((new Date(from) - new Date()) / 86400000) + 1;
	// 			}
	// 			setCookie('nb_rewards', pre, dayLeft);
	// 			$(widget).addClass('show');
	// 			if ($(popup).hasClass('page_show')) {
	// 				$(popup).addClass('show');
	// 			}
	// 		} else if ($(widget).hasClass('pre')) {
	// 			return;
	// 		}
	// 		$(widget).addClass('show');
	// 		let show = $d.find('#nbgp-products').length > 0;
	// 		if (getCookie('nb_gifts') === 'hidden') {
	// 			show = false;
	// 		}
	// 		if (show) {
	// 			T4SThemeSP.initCarousel();
	// 		}
	// 		$g.find(popup).toggleClass('show', show);
	// 	});
}
document.addEventListener('nubest:cart:done', ()=> checkNBGift());
$(document).ready(function () {
	!(function () {
		if (!document.getElementById('nb-gifts')) return;
		const startIdentificationCheck = () => {
			if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') return;
			let attempts = 0;
			const timer = setInterval(async () => {
				attempts += 1;
				try {
					if (await window.klaviyo.isIdentified()) {
						clearInterval(timer);
						checkNBGift('submit_form');
						return;
					}
				} catch (error) {}
				if (attempts > 20) clearInterval(timer);
			}, 500);
		};
		const hookKlaviyoSubscribe = (attempt = 0) => {
			if (!window.KlaviyoSubscribe || typeof window.KlaviyoSubscribe.log !== 'function') {
				if (attempt < 40) setTimeout(() => hookKlaviyoSubscribe(attempt + 1), 250);
				return;
			}
			const originalLog = window.KlaviyoSubscribe.log;
			if (originalLog.__nubestGiftHook) return;
			const wrappedLog = function (...args) {
				if (args[0] === 'Waiting for DOM to process queue.') checkNBGift();
				if (args[0] === '$source') startIdentificationCheck();
				return originalLog.apply(this, args);
			};
			wrappedLog.__nubestGiftHook = true;
			window.KlaviyoSubscribe.log = wrappedLog;
		};
		hookKlaviyoSubscribe();
	})();
	if (/^\/products\/gift-(?!card(?:\/|$))/.test(window.location.pathname)) {
		window.location.replace(window.location.href.replace('/gift-', '/'));
	}
	$(document).on('click', '#nb-gift-widget', function (e) {
		$('#nb-gift-iframe').toggleClass('show');
	});
	$(document).on('click', '[data-nb-gift-close]', function (e) {
		setCookie('nb_gifts', 'hidden', $(this).hasClass('popup-hidden') ? 2 : 0);
		$(this).closest('.show').removeClass('show');
	});
	$(document).on('click', '.nbgio-products-more', function (e) {
		$('#nb-gift-iframe .nbgio-products .hide').removeClass('hide');
		$(this).remove();
	});
	$(document).on('click', '[data-nb-gift-popup]', function (e) {
		$('#nb-gift-popup').addClass('show');
		T4SThemeSP.initCarousel();
	});
});
//================================ End NuBest Gifts =====================================
//================================ tamix-popup-parent =====================================
function openTamixPopup() {
	document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background').forEach((bg) => bg.classList.add('active'));
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((el) => {
			el.style.transform = 'translateY(0px)';
		});
		TamixPopup_addSwipeToClose('.tamix-popup-parent-section', closeTamixPopup);
	}, 200);
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((parent) => parent.classList.add('transition-0'));
	}, 500);
	document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background').forEach((bg) => {
		bg.addEventListener('click', function (event) {
			if (event.target === bg) {
				closeTamixPopup();
			}
		});
	});
}
function closeTamixPopup() {
	document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((el) => el.classList.remove('transition-0'));
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background .tamix-popup-parent').forEach((el) => {
			el.style.transform = 'translateY(100%)';
		});
	}, 100);
	setTimeout(() => {
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-parent .tamix-popup-parent-body  .tamix-popup-parent-content').forEach((el) => (el.innerHTML = ''));
		document.querySelectorAll('.tamix-popup-parent-section .tamix-popup-background').forEach((el) => el.classList.remove('active'));
		TamixPopup_removeSwipeToClose('.tamix-popup-parent-section');
	}, 600);
}
let TamixPopup_startY = 0;
let TamixPopup_lastY = 0;
let TamixPopup_originY = 0;
let TamixPopup_isSwiping = false;
let TamixPopup_popupContent = null;
let TamixPopup_currentTranslateY = 0;
let TamixPopup_hasStarted = false;
function TamixPopup_addSwipeToClose(popupSelector, onClose) {
	const TamixPopup_popup = document.querySelector(popupSelector);
	if (!TamixPopup_popup) return;
	TamixPopup_popupContent = TamixPopup_popup.querySelector('.tamix-popup-parent');
	if (!TamixPopup_popupContent) return;
	function TamixPopup_getY(e) {
		return e.touches ? e.touches[0].clientY : e.clientY;
	}
	function TamixPopup_onStart(e) {
		const y = TamixPopup_getY(e);
		TamixPopup_startY = y;
		TamixPopup_originY = y;
		TamixPopup_lastY = y;
		TamixPopup_currentTranslateY = 0;
		TamixPopup_isSwiping = true;
		TamixPopup_hasStarted = true;
	}
	function TamixPopup_onMove(e) {
		e.preventDefault();
		if (!TamixPopup_isSwiping || !TamixPopup_hasStarted) return;
		const TamixPopup_currentY = TamixPopup_getY(e);
		const TamixPopup_delta = TamixPopup_currentY - TamixPopup_lastY;
		//console.log("TamixPopup_delta Move: " + TamixPopup_delta );
		TamixPopup_lastY = TamixPopup_currentY;
		TamixPopup_currentTranslateY += TamixPopup_delta;
		if (TamixPopup_currentTranslateY < 0) TamixPopup_currentTranslateY = 0;
		TamixPopup_popupContent.style.transform = `translateY(${TamixPopup_currentTranslateY}px)`;
		if (Math.abs(TamixPopup_currentY - TamixPopup_startY) >= 20 && TamixPopup_delta > 0) {
			TamixPopup_startY = TamixPopup_currentY;
		}
	}
	function TamixPopup_onEnd(e) {
		if (!TamixPopup_isSwiping) return;
		const TamixPopup_delta = TamixPopup_lastY - TamixPopup_startY;
		const TamixPopup_currentPosition = TamixPopup_lastY - TamixPopup_originY;
		// console.log("TamixPopup_delta End: " + TamixPopup_delta );
		//console.log("TamixPopup_currentPosition: " + TamixPopup_currentPosition );
		if (TamixPopup_delta >= 0 && TamixPopup_currentPosition > 120) {
			onClose();
		} else {
			TamixPopup_popupContent.style.transition = 'transform 0.3s ease';
			TamixPopup_popupContent.style.transform = 'translateY(0)';
			TamixPopup_currentTranslateY = 0;
			setTimeout(() => {
				if (TamixPopup_popupContent) {
					TamixPopup_popupContent.style.transition = '';
				}
			}, 300);
		}
		TamixPopup_isSwiping = false;
		TamixPopup_hasStarted = false;
	}
	window.addEventListener('touchstart', TamixPopup_onStart);
	window.addEventListener('touchmove', TamixPopup_onMove, { passive: false });
	window.addEventListener('touchend', TamixPopup_onEnd);
	window.addEventListener('mousedown', TamixPopup_onStart);
	window.addEventListener('mousemove', TamixPopup_onMove);
	window.addEventListener('mouseup', TamixPopup_onEnd);
	TamixPopup_popup._swipeHandlers = {
		onStart: TamixPopup_onStart,
		onMove: TamixPopup_onMove,
		onEnd: TamixPopup_onEnd,
	};
}
function TamixPopup_removeSwipeToClose(popupSelector) {
	const TamixPopup_popup = document.querySelector(popupSelector);
	if (!TamixPopup_popup || !TamixPopup_popup._swipeHandlers || !TamixPopup_popupContent) return;
	const { onStart: TamixPopup_onStart, onMove: TamixPopup_onMove, onEnd: TamixPopup_onEnd } = TamixPopup_popup._swipeHandlers;
	window.removeEventListener('touchstart', TamixPopup_onStart);
	window.removeEventListener('touchmove', TamixPopup_onMove);
	window.removeEventListener('touchend', TamixPopup_onEnd);
	window.removeEventListener('mousedown', TamixPopup_onStart);
	window.removeEventListener('mousemove', TamixPopup_onMove);
	window.removeEventListener('mouseup', TamixPopup_onEnd);
	delete TamixPopup_popup._swipeHandlers;
}
function checkTamixPopup(name, item) {
	if (name && item.id) {
		const id = 'tamix-popup-parent-section';
		const sid = '#shopify-section-' + id;
		let s = name;
		let c = $(sid).length;
		if (!c) s += ',' + id;
		NuBestCart.section(s, {
			url: item.url.split('?')[0],
			done: (sections) => {
				let d = $(sections[name]);
				if (d.html().trim()) {
					if (!c) $('body').append(sections[id]);
					$(sid).find('.tamix-popup-parent-content').append(d);
					setTimeout(() => {
						openTamixPopup();
					}, 2000);
				}
			},
		});
	}
}
$(document).ready(function () {
	$(document).on('click', '.btn-addtocart-product-pairing', function (event) {
		// console.log('btn-addtocart-product-pairing');
		$(this).addClass('is--loading');
		$(this).prop('disabled', true);
		$(this).find('.t4s-loading__spinner, .t4s-loading__spinner svg').removeAttr('hidden');
		NuBestCart.add(paramATC(this), {
			done: (cart) => {
				$(this).text('Added');
			},
		});
	});
});
//================================ End tamix-popup-parent =====================================
async function ipGeoLocation() {
	let geo = getCookie('ipgeolocation');
	if (geo) {
		try {
			return JSON.parse(geo);
		} catch {}
	} else {
		try {
			const res = await fetch('https://api.ipgeolocation.io/v2/ipgeo?apiKey=c4ddfac0f1f0411a8682871b7b707792');
			const data = await res.json();
			setCookie('ipgeolocation', JSON.stringify(data), 7);
			return data;
		} catch (error) {}
	}
}
document.addEventListener('DOMContentLoaded', async (event) => {
	let prop65 = $('[data-prop65-warning]');
	if (prop65.length) {
		const data = await ipGeoLocation();
		if (data && data.location) {
			const state_code = data.location.state_code;
			if (state_code == 'US-CA') {
				NuBestCart.section('prop65-warning', {
					done: (sections) => {
						prop65.html(sections);
					},
				});
			}
		}
	}
});
// document.addEventListener('DOMContentLoaded', (event) => {
// 	$(document).on('click', '.tamix-mini-buybox .sns-item', function (event) {
// 		let contain = $(this).closest('.tamix-mini-buybox');
// 		contain.find('.sns-item').removeClass('active');
// 		$(this).addClass('active');
// 		let variant = contain.find('.variant-item.active');
// 		contain.find('[name="id"]').val(variant.data('id'));
// 		contain.find('[name="selling_plan"]').val($(this).hasClass('sns-item-sub') ? variant.data('spid') : '');
// 	});
// 	$(document).on('click', '.tamix-mini-buybox .variant-item', function (event) {
// 		let contain = $(this).closest('.tamix-mini-buybox');
// 		contain.find('.variant-item').removeClass('active');
// 		$(this).addClass('active');
// 		contain.find('[name="id"]').val($(this).data('id'));
// 		contain.find('[name="selling_plan"]').val(contain.find('.sns-item-sub.active').length ? $(this).data('spid') : '');
// 		let image = contain.find('.tamix-mini-buybox-image img').prop('outerHTML');
// 		let image_replace = image.replaceAll(image.split('data-srcset="')[1].split('?')[0], `//www.nubest.com/cdn/shop/${$(this).data('image')}`);
// 		contain.find('.tamix-mini-buybox-image img').replaceWith(image_replace);
// 		contain.find('[buybox-price_old]').text($(this).data('price_old') > $(this).data('price') ? formatCC($(this).data('price_old')) : '');
// 		contain.find('[buybox-price]').text(formatCC($(this).data('price')));
// 		contain.find('[buybox-label]').text($(this).data('label')).css('background', $(this).data('label_color'));
// 		contain.find('[buybox-discount_text]').text($(this).data('discount_text'));
// 		contain.find('[buybox-discount_text_2]').text($(this).data('discount_text_2') ? `(${$(this).data('discount_text_2')})` : '');
// 	});
// });
// Snippets tamix-remove-iherb-param
(function () {
	const TARGET_DOMAIN = 'iherb.com';
	const PARAM_TO_REMOVE = 'rcode';
	const VALUE_TO_REMOVE = 'LUI5678';
	const SOURCE_KEYWORDS = ['facebook', 'instagram', 'google', 'tiktok', 'youtube', 'taboola', 'bing'];
	const currentUrlParams = new URLSearchParams(window.location.search);
	const allParamValues = Array.from(currentUrlParams.values()).join(' ').toLowerCase();
	const isTargetSource = SOURCE_KEYWORDS.some((keyword) => allParamValues.includes(keyword));
	if (!isTargetSource) return;
	function cleanIHerbLinks() {
		const selector = `a[href*="${TARGET_DOMAIN}"][href*="${PARAM_TO_REMOVE}=${VALUE_TO_REMOVE}"]`;
		const links = document.querySelectorAll(selector);
		links.forEach((link) => {
			try {
				const url = new URL(link.href);
				if (url.hostname.includes(TARGET_DOMAIN)) {
					if (url.searchParams.get(PARAM_TO_REMOVE) === VALUE_TO_REMOVE) {
						url.searchParams.delete(PARAM_TO_REMOVE);
						link.href = url.toString();
					}
				}
			} catch (e) {
				// ignore invalid URLs
			}
		});
	}
	let cleanScheduled = false;
	function scheduleCleanIHerbLinks() {
		if (cleanScheduled) return;
		cleanScheduled = true;
		const run = () => {
			cleanScheduled = false;
			cleanIHerbLinks();
		};
		if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1000 });
		else setTimeout(run, 500);
	}
	scheduleCleanIHerbLinks();
	const observer = new MutationObserver((mutations) => {
		if (mutations.some((m) => m.addedNodes.length > 0)) {
			scheduleCleanIHerbLinks();
		}
	});
	observer.observe(document.body, { childList: true, subtree: true });
})();
// HP-newOddit-Block-02-snippet
document.addEventListener('DOMContentLoaded', function () {
	var marqueeElement = document.querySelector('[x-data="marquee"]');
	if (marqueeElement && window.matchMedia('(max-width: 991px)').matches) {
		document.querySelectorAll('.HP-newOddit-Block-02-snippet img[data-src]').forEach((image) => {
			image.src = image.dataset.src;
			image.removeAttribute('data-src');
		});
		let ua = function () {
			return {
				marqueeInner: null,
				marqueeEls: null,
				marqueeSpeed: null,
				marqueePrepend: !1,
				centerOnFit: !1,
				marqueeWidth: 0,
				marqueeHeight: 0,
				init: function () {
					var e = this;
					setTimeout(function () {
						e.marqueeLogic();
					}, 100);
				},
				marqueeLogic: function () {
					var e = this;
					if (
						((this.marqueeInner = this.$el.closest('[data-marquee-inner]')),
						(this.marqueeEls = this.$el.querySelectorAll('[data-marquee-el]')),
						(this.marqueeSpeed = this.$el.getAttribute('data-marquee-speed')),
						(this.marqueePrepend = this.$el.hasAttribute('data-marquee-prepend')),
						(this.centerOnFit = this.$el.hasAttribute('data-center-fit')),
						(this.marqueeWidth = 0),
						(this.marqueeHeight = 0),
						this.marqueeEls.forEach(function (t) {
							var n = t.getBoundingClientRect().width,
								r = t.getBoundingClientRect().height;
							((n += parseInt(window.getComputedStyle(t).getPropertyValue('margin-left'))), (n += parseInt(window.getComputedStyle(t).getPropertyValue('margin-right'))), (r += parseInt(window.getComputedStyle(t).getPropertyValue('margin-top'))), (r += parseInt(window.getComputedStyle(t).getPropertyValue('margin-bottom'))), (e.marqueeWidth += n), r > e.marqueeHeight && (e.marqueeHeight = r));
						}),
						this.$el.querySelectorAll('[data-clone-marquee-el], [data-pre-clone-marquee-el]').forEach(function (e) {
							return e.remove();
						}),
						this.marqueeWidth)
					) {
						var t = this.marqueeInner.getBoundingClientRect().width - parseFloat(window.getComputedStyle(this.marqueeInner).paddingLeft) - parseFloat(window.getComputedStyle(this.marqueeInner).paddingRight);
						if (((this.$el.style.width = ''.concat(this.marqueeWidth, 'px')), (this.marqueeInner.style.height = ''.concat(this.marqueeHeight, 'px')), this.marqueeWidth < t && this.centerOnFit)) return (this.$el.removeAttribute('style'), this.marqueeInner.classList.add('justify-center', 'container'), this.$el.classList.remove('marquee', 'absolute'), this.$el.classList.add('static', 'w-full', 'justify-center'), void (this.marqueePrepend = !1));
						(this.$el.style.setProperty('--marquee-speed', this.marqueeSpeed), this.$el.classList.add('marquee', 'absolute'), this.$el.classList.remove('static', 'w-full', 'justify-between'), this.marqueeInner.classList.remove('justify-center', 'container'));
						var n = Math.ceil(window.innerWidth / this.marqueeWidth);
						(this.marqueePrepend && ((this.$el.style.width = 'max-content'), (this.$el.style.transform = this.$el.style.transform || 'translateX(-50%)'), (this.$el.style.left = '50%'), (n /= 2) % 2 != 0 && n++), this.calculateDuplicates(this.marqueeEls, n));
					}
				},
				calculateDuplicates: function (e, t) {
					for (var n = this, r = 0; r < t; r++)
						e.forEach(function (t) {
							var r = t.cloneNode(!0);
							if ((r.removeAttribute('data-marquee-el'), r.setAttribute('data-clone-marquee-el', !0), n.marqueePrepend)) {
								var i = t.cloneNode(!0);
								(i.removeAttribute('data-marquee-el'), i.setAttribute('data-pre-clone-marquee-el', !0), e[0].before(i));
							}
							n.$el.appendChild(r);
						});
				},
			};
		};
		let marqueeInstance = ua();
		marqueeInstance.$el = marqueeElement;
		marqueeInstance.init();
	}
});
// (function () {
// 	var r = 'data-atomato-js-loaded';
// 	function d() {
// 		var t = document.getElementById('atomato-app');
// 		if (!(!t || t.getAttribute(r))) {
// 			var n = t.getAttribute('data-js-href');
// 			if (n) {
// 				t.setAttribute(r, 'true');
// 				var o = t.getAttribute('data-css-href');
// 				if (o && !document.querySelector('link[data-atomato-css-preload]')) {
// 					var e = document.createElement('link');
// 					((e.rel = 'preload'), (e.as = 'style'), (e.href = o), e.setAttribute('data-atomato-css-preload', 'true'), document.head.appendChild(e));
// 				}
// 				var a = document.createElement('script');
// 				((a.src = n), (a.async = !0), document.head.appendChild(a));
// 			}
// 		}
// 	}
// 	document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', d) : d();
// })();

function updatePrice(container) {
  if (!container) return;

  const form = container.querySelector('form');
  const variantsJSON = container.querySelector('.pr_variants_json');

  if (!form || !variantsJSON) return;

  let variants;

  try {
    variants = JSON.parse(variantsJSON.textContent);
  } catch (error) {
    console.error('NuBest: Invalid variants JSON', error);
    return;
  }

  // Get selected variant options (supports 1, 2 or 3 options)
  const selectedOptions = [...container.querySelectorAll(
    '[data-swatch-option]'
  )]
    .sort((a, b) => Number(a.dataset.id) - Number(b.dataset.id))
    .map(group =>
      group.querySelector('[data-swatch-item].is--selected')
        ?.dataset.value
    );

  if (!selectedOptions.length || selectedOptions.some(v => !v)) {
    return;
  }

  const variant = variants.find(v =>
    selectedOptions.every((value, index) =>
      v.options?.[index] === value
    )
  );

  if (!variant) return;

  const formatPrice = cents =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);

  // Update One-time price
  const oneTimePrice = form.querySelector(
    '.onetime-radio .price-label'
  );

  if (oneTimePrice) {
    oneTimePrice.textContent = formatPrice(variant.price);
  }

  // Get selling plan allocation
  const planSelect = form.querySelector('.sp-list-opt');
  const sellingPlanId = planSelect?.value;

  const allocations = variant.selling_plan_allocations || [];

  const allocation = allocations.find(plan =>
    String(plan.selling_plan_id) === String(sellingPlanId)
  );

  // Update Subscription price
  const subscriptionPrice = form.querySelector(
    '.subscription-radio .price-label'
  );

  if (subscriptionPrice) {
    subscriptionPrice.textContent = allocation
      ? formatPrice(allocation.price)
      : formatPrice(variant.price);
  }

  // Subscription widget
  const widget = form.querySelector('.nb-sp-widget');

  if (widget) {
    widget.classList.toggle('disabled', !allocation);
  }

  const oneTimeRadio = form.querySelector(
    '.selling_plan_option[value="onetime"]'
  );

  const subscriptionRadio = form.querySelector(
    '.selling_plan_option[value="subscription"]'
  );

  // Disable subscription when unavailable
  if (subscriptionRadio) {
    subscriptionRadio.disabled = !allocation;
  }

  // Automatically switch to One-time
  if (!allocation && oneTimeRadio && !oneTimeRadio.checked) {
    oneTimeRadio.click();
  }

  const isSubscription = Boolean(
    allocation && subscriptionRadio?.checked
  );

  // Synchronize hidden selling plan
  const sellingPlanInput = form.querySelector(
    'input[name="selling_plan"]'
  );

  if (sellingPlanInput) {
    sellingPlanInput.value = isSubscription
      ? String(allocation.selling_plan_id)
      : '';

    sellingPlanInput.disabled = !isSubscription;
  }

  // Synchronize active radio classes
  form.querySelector('.onetime-radio')?.classList.toggle(
    'sp-radio--active',
    !isSubscription
  );

  form.querySelector('.subscription-radio')?.classList.toggle(
    'sp-radio--active',
    isSubscription
  );

  // Synchronize Purchase heading
  const purchaseType = form.querySelector(
    '.selling-plan__purchase-type'
  );

  if (purchaseType) {
    purchaseType.textContent = isSubscription
      ? 'Subscription'
      : 'One-time';
  }
}

// Handle variant option selection
document.addEventListener('click', function(event) {
  const swatch = event.target.closest('[data-swatch-item]');

  if (!swatch) return;

  const container = swatch.closest(
    '.t4s-product-form__variants'
  );

  if (!container) return;

  // Wait for T4S to update selected option
  requestAnimationFrame(() => {
    requestAnimationFrame(() => updatePrice(container));
  });
});

// Handle purchase type and subscription frequency
document.addEventListener('change', function(event) {
  if (!event.target.matches(
    '.sp-list-opt, .selling_plan_option'
  )) return;

  const container = event.target.closest(
    '.t4s-product-form__variants'
  );

  if (container) updatePrice(container);
});

// Initial synchronization when page loads
function initNuBestPrices() {
  document.querySelectorAll(
    '.t4s-product-form__variants'
  ).forEach(container => updatePrice(container));
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initNuBestPrices
  );
} else {
  initNuBestPrices();
}
